import { ReactElement, useState } from 'react';

import { ArrowUpSvg } from '@cashier/cashier-assets';
import { Directions } from '@cashier/cashier-model';
import { eventBus, EventFactory } from '@cashier/cashier-shared';
import { cn } from '@cashier/cashier-ui';

import { useCashierConfiguration } from '../../hooks';

import s from './styles.module.scss';

interface FieldProps {
  name: string;
  logoSrc: string;
}

export const PaymentMethodButton = ({
  name,
  logoSrc,
}: FieldProps): ReactElement => {
  const [active, setActive] = useState(false);

  const { direction } = useCashierConfiguration();
  const changePaymentMethod = () => {
    setActive(true);

    eventBus.emit(EventFactory.changePaymentMethod('open payment methods'));

    setTimeout(() => {
      setActive(false);
    }, 1000);
  };

  return (
    <div className={s.wrapperCurrentMethod}>
      <button
        type="button"
        className={cn({
          [s.logoContainer]: true,
        })}
        onClick={changePaymentMethod}
        data-test="select-account-placeholder"
      >
        <img className={s.logo} src={logoSrc} alt={name} />
        <span
          className={cn({
            [s.active]: active,
            [s.rtl]: direction === Directions.Rtl,
          })}
        >
          <svg className={s.arrowSvg}>
            <ArrowUpSvg />
          </svg>
        </span>
      </button>
    </div>
  );
};
